<!-- Custom upgrade plan tooltip, can be wrapped around a UI component -->

<template>
  <div class="tooltip-container">
    <div :style="{...this.style, opacity: showTooltip ? 0.5 : 1, display:'flex', alignItems:'flex-start', justifyContent:'flex-start'}">
          <slot/>
    </div>
    <template v-if="showTooltip">
        <div :class="{
          'tooltip': true,
          'tooltip-error': type === 'error',
          'tooltip-info': type === 'info'
        }" :style="type=='upgrade-cue' ? 'width: 268px' : 'width: 228px'">
          <div class="upgrade-cue-confirmation" v-if="showConfirmation">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
              <path d="M24.3442 11.2538C25.3049 11.7244 26.385 11.9886 27.5269 11.9886C28.0231 11.9886 28.5076 11.9387 28.9757 11.8437V27.9252C28.9757 28.7254 28.327 29.374 27.5269 29.374H1.44878C0.648649 29.374 0 28.7254 0 27.9252V4.74468C0 3.94455 0.648649 3.2959 1.44878 3.2959H20.4278C20.3328 3.76401 20.283 4.24852 20.283 4.74468C20.283 6.53642 20.9335 8.17623 22.0112 9.4408L14.5756 15.8755L5.28403 7.98662L3.40867 10.1954L14.5937 19.6919L24.3442 11.2538Z" fill="#D2DCFB"/>
              <path d="M23.3071 4.74479C23.3071 7.1452 25.253 9.09114 27.6535 9.09114C30.054 9.09114 31.9998 7.1452 31.9998 4.74479C31.9998 2.34437 30.054 0.398438 27.6535 0.398438C25.253 0.398438 23.3071 2.34437 23.3071 4.74479Z" fill="#5B7EDB"/>
            </svg>
            <p class="mt-3 mb-1">Thank you for your interest!</p>
            <p>We’ll send you an email with next steps.</p>
          </div>
          <template v-else>
          <h3 v-if="title" class="tooltip-title">{{title}}
              <i class="ri-information-line"></i>
            </h3>
            <p :class="type=='upgrade-cue' ? 'upgrade-cue-text' : 'tooltip-text looppanel-typography-small'">{{message}}</p>
            <button v-if="type !== 'info'" :class="type=='error' ? 'upgrade-cta upgrade-cta-error': 'upgrade-cta'" @click="toggleUpgradePlanModal">
              <template v-if="type=='upgrade-cue'">
                Contact Us
              </template>
              <template v-else>
                Upgrade
              </template>
            </button>
          </template>
        </div>
    </template>
  </div>
</template>

<script>
import { auth } from "@/firebase";

    export default {
        data(){
          return {
            showConfirmation: false
          };
        },
        props:{
            title:{
                default: null,
                type: String
            },
            type:{
              default:'error'
            },
            style: {},
            showTooltip: {
                default: false,
                type: Boolean
            },
            message: {
              default: "Your Free Trial has ended. Please upgrade to enable this action",
              type: String
            },
            renderedIn:{
              type:String
            }
        },
        methods: {
            toggleUpgradePlanModal(){
                window.analytics.track(`click on Upgrade ${this.type=='upgrade-cue' ? 'cue' : ''} from ${this.renderedIn}`, {
                    email: auth.currentUser.email,
                });
                if(this.type=='upgrade-cue'){
                  console.log('send a notifaction to slack')
                  this.showConfirmation = true
                }else{
                  this.$store.dispatch('toggleUpgradePlanModal',true)
                }
            }
        }
    }
</script>

<style scoped>

.tooltip-container { 
  position: relative;
  display: inline-block;
  /* margin:100px; */
}

.tooltip-container:hover .tooltip{
  opacity: 1;

}

.tooltip { 
  text-align: center;
  padding: 5px 0;
  border-radius: 2px;
  /* width: 228px; */
  height: auto;
  top: 100%;
  left: 50%;
  margin-left: -114px;
  opacity: 0;
  transition: opacity 0.5s;
  position: absolute;
  z-index: 1;
  background: #FAFBFE;
  border: 1px solid #D2DCFB;
  box-shadow: 0px 0px 8px 0px #66666626;
  border-radius: 8px;
  padding: 10px;
  text-align: left;
  margin-top: 3px;
}

.tooltip-error{
  background: #FFF5F5;
  border: 1px solid #C530301A;
}

.tooltip-info {
  background: #F6F8FE;
  border: 1px solid #E8EDFC;
}

.tooltip-text{
    text-align: left;
    color: var(--dark-grey-font-color);
    margin-bottom: 0px
}

.upgrade-cta {
    /* width: 75px; */
    height: 26px;
    padding: 4px 12px 4px 12px;
    border-radius: 32px;
    background: #5B7EDB;
    color: #FFFFFF;
    font-family: Inter;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    cursor: pointer;
    margin-bottom: 5px;
    margin-top: 10px;
}

.upgrade-cta-error{
  background: #C53030;
}

.text::after {
  content: " ";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 10px;
  border-style: solid;
  border-color:  transparent transparent #FFF5F5 transparent ;

}

.tooltip-title{
  color: var(--Primary-500, #5B7EDB);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
  margin-bottom: 5px;
}
.tooltip-title i{
  color: #B2B2B2;
}
.upgrade-cue-text{
  color: var(--Neutrals-600, #4C4C4C);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
}
.upgrade-cue-confirmation>p{
  color: var(--Neutrals-600, #4C4C4C);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
}
.upgrade-cue-confirmation p+p{
  color: var(--Neutrals-600, #4C4C4C);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
}
</style>

